module.exports = __webpack_public_path__ + "img/1579757758.070ff6db.jpg";